import React from "react";
import { MainContainer } from "../styles/sharedStyles"; // Import shared styles
import Title from "../../components/title/Title";
import TextParagraph from "../../components/text/TextParagraph";

const CoachingNutrition = () => {
  return (
    <MainContainer>
      <Title
        title="Coaching Nutrition"
        summary="Ton plan nutritionnel sur-mesure adapté à ton style de vie et à tes objectifs."
      />

      <TextParagraph
        content={`<p>Tu veux rééquilibrer ton alimentation sans te prendre la tête ? 🍎 Le coaching nutrition est fait pour toi !</p>`}
      />

      <TextParagraph
        content={`<p>Voici ce que je t'offre :</p>
        <ul>
          <li>✅ <strong>Plan alimentaire personnalisé :</strong> adapté à tes goûts, ton rythme de vie et tes objectifs (sans privation inutile !).</li>
          <li>✅ <strong>Recettes faciles et gourmandes :</strong> pour varier tes repas et te régaler sans culpabiliser.</li>
          <li>✅ <strong>Aide pour suivre le plan :</strong> des astuces et conseils pour rester motivé(e) et sur la bonne voie.</li>
          <li>✅ <strong>Communication via WhatsApp :</strong> je suis toujours dispo pour répondre à tes questions et te booster.</li>
          <li>✅ <strong>Bilan hebdomadaire :</strong> chaque semaine, on ajuste le plan ensemble en fonction de tes résultats et de ton ressenti.</li>
        </ul>`}
      />

      <TextParagraph
        content={`<p>Tu ne seras jamais seul(e) : un groupe WhatsApp te permettra aussi d’échanger avec d’autres personnes qui suivent le même programme. Ensemble, on va plus loin ! 💬✨</p>`}
      />
    </MainContainer>
  );
};

export default CoachingNutrition;
